import React, { memo } from 'react';

import { areEqual } from 'Utils/equalityChecks';

import { Thumbnail } from 'Containers/Thumbnail';
import { SecondarySpinner } from 'Components/SecondarySpinner';

import classes from './photo.module.css';

interface Props {
  id: number | string;
  galleryInstanceId?: string;
  roomId?: number;
  albumId?: number;
  galleryTitle?: string;
  large?: string;
  isLastItem: boolean;
  editable: boolean;
  photosCount: number;
  notesCount?: number;
  createdAt?: string;
  isBookmarked?: boolean;
  isFlagged?: boolean;
  isPhotoSelected?: boolean;
  onClickThumbnail: (e: any) => void;
  setRefreshOnDelete: (e: any) => void;
  pending?: boolean;
  fileName?: string;
}

const Photo = ({
  id,
  galleryInstanceId,
  roomId,
  albumId,
  galleryTitle,
  large,
  editable,
  onClickThumbnail,
  photosCount,
  notesCount,
  createdAt,
  isBookmarked,
  isFlagged,
  isPhotoSelected,
  isLastItem,
  setRefreshOnDelete,
  pending,
  fileName,
}: Props) =>
  pending ? (
    <div className={`${classes.photoBase} ${classes.pending}`}>
      <SecondarySpinner loading />
      <div className={classes.pendingName} title={fileName || 'Uploading...'}>
        {fileName || 'Uploading...'}
      </div>
    </div>
  ) : (
    <Thumbnail
      id={id}
      thumbnailSurface="room_gallery"
      galleryInstanceId={galleryInstanceId}
      roomId={roomId}
      albumId={albumId}
      galleryTitle={galleryTitle}
      className={classes.photoBase}
      thumbnailSrcUrl={large}
      onClick={onClickThumbnail}
      photosCount={photosCount}
      notesCount={notesCount}
      createdAt={createdAt}
      isBookmarked={isBookmarked}
      isFlagged={isFlagged}
      readonly={!editable}
      isLastItem={isLastItem}
      isPhotoSelected={isPhotoSelected}
      setRefreshOnDelete={setRefreshOnDelete}
    />
  );

Photo.defaultProps = {
  createdAt: undefined,
  pending: false,
  fileName: '',
  notesCount: 0,
  isBookmarked: false,
  isFlagged: false,
  isPhotoSelected: false,
};

const PhotoMemo = memo(Photo, areEqual);

export { PhotoMemo as Photo };
